import { getConfig } from '@config/index'

import { IS_BROWSER, IS_DEVELOPMENT } from '@constants/globals'

const config = getConfig()

export interface PixelExperimentTracker {
  trackAssignment: (experimentName: string) => void
  generatePixelUrl: (isPreview?: boolean) => string | null
  getAssignedExperimentNames: () => string[]
}

/**
 * Server-side tracker for pixel experiments that need client-side assignment tracking
 */
export class PixelExperimentTrackerImpl implements PixelExperimentTracker {
  private readonly assignedExperiments: Set<string> = new Set()
  private readonly shouldTrack: boolean

  constructor(shouldTrack: boolean) {
    this.shouldTrack = shouldTrack
  }

  /**
   * Track an assigned pixel experiment during SSR
   */
  trackAssignment(experimentName: string): void {
    if (this.shouldTrack) {
      this.assignedExperiments.add(experimentName)
    }
  }

  /**
   * Get all tracked experiment names for pixel injection
   */
  getAssignedExperimentNames(): string[] {
    return [...this.assignedExperiments]
  }

  /**
   * Generate pixel URL for experiment assignment tracking
   */
  generatePixelUrl(isPreview?: boolean): string | null {
    const assignedExperiments = this.getAssignedExperimentNames()

    if (assignedExperiments.length === 0) {
      return null
    }

    const baseUrl = IS_DEVELOPMENT && IS_BROWSER ? window.location.origin : config.paths.basePath

    const url = new URL('/api/v1/treatments/assign', baseUrl)

    // Add experiment names as query parameter
    url.searchParams.set('experiments', assignedExperiments.join(','))

    // #ToDo Add user ID, container ID and other

    // Add preview mode if applicable
    if (isPreview) {
      url.searchParams.set('isPreview', 'true')
    }

    return url.toString()
  }
}
